/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ActivateUserResponse {
    getFixupPrototypeFunction() { return ActivateUserResponse.fixupPrototype; }

    static newInstance(model: Partial<ActivateUserResponse>): ActivateUserResponse {
        let obj = Object.assign(new ActivateUserResponse(), model);
        ActivateUserResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ActivateUserResponse>): ActivateUserResponse {
        if (!model) return null;
        return ActivateUserResponse.newInstance(<ActivateUserResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ActivateUserResponse) {
        if (!obj) return;

        models.ActivateUserResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ActivateUserResponse): boolean {
        Object.setPrototypeOf(obj, ActivateUserResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * User ID
     */
    user_id: string;

}
